import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { errorSnack, successSnack } from "../snackbar/snackbarSlice";

import api from "../../app/api";

import { uuidv4 } from "../../app/utils";
import baseURL from "../../app/utils.js";

export const resetProduct = createAction("clientProducts/resetProduct");

export const fetchProducts = createAsyncThunk(
  "clientProducts/fetchProducts",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await api.get(
        `${baseURL}/v1/admin/products${args.query}`,
        config
      );
      thunkAPI.dispatch(setProductsAmount(response.headers["x-total-count"]));
      thunkAPI.dispatch(setLastQuery(args.query));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching products list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreProducts = createAsyncThunk(
  "clientproducts/fetchMoreProducts",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await api.get(
        `${baseURL}/v1/admin/products${args.query}&offset=${args.offset}`,
        config
      );
      // let catQuery = [];
      // if (args.query.includes("categories")) {
      //   let urlSearchParams = new URLSearchParams(args.query);
      //   let params = Object.fromEntries(urlSearchParams.entries());
      //   catQuery = params.categories;
      // }
      // thunkAPI.dispatch(setLastQuery(args.query));
      // thunkAPI.dispatch(setProductsAmount(response.headers["x-total-count"]));
      // thunkAPI.dispatch(updateCategories(catQuery));
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchProductByID = createAsyncThunk(
  "clientProducts/fetchProductByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/admin/products/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching product data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createProduct = createAsyncThunk(
  "products/createProduct",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/products`,
        args.product,
        config
      );
      thunkAPI.dispatch(successSnack("Product created successfully"));
      thunkAPI.dispatch(
        fetchProducts({ token: args.token, query: "?limit=25" })
      );

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating product"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.patch(
        `${baseURL}/v1/admin/products/${args.id}`,
        args.product,
        config
      );
      thunkAPI.dispatch(
        fetchProducts({ token: args.token, query: "?limit=25" })
      );
      // thunkAPI.dispatch(fetchProductByID({ token: args.token, id: args.id }));

      // thunkAPI.dispatch(successSnack('Product updated'));
      thunkAPI.dispatch(successSnack("Product details updated successfully"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating product"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "clientProducts/deleteProduct",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.delete(
        `${baseURL}/v1/admin/products/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Product deleted successfully"));
      return await response;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting product"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const preSignedURL = createAsyncThunk(
  "clientproducts/preSignedURL",
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
      },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/pre_signed_url`,

        {
          objectName: args.objectName,
          objectType: args.objectType,
          objectContentType: args.contentType,
          download: args.download,
        },
        config
      );
      if (response.data.preSignedURL && !args.download) {
        thunkAPI.dispatch(
          uploadCSV({
            token: args.token,
            csvFile: args.csvFile,
            url: response.data.preSignedURL,
            contentType: args.contentType,
            localization: args.localization,
          })
        );
      }
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error creating pre-signed url for AWS upload"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const uploadCSV = createAsyncThunk(
  "clientproducts/uploadCSV",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          // Authorization: `Bearer ${args.token}`,
          "Content-Type": args.contentType,
        },
        //
      };
      const response = await api.put(`${args.url}`, args.csvFile, config);
      if (response.status === 200) {
        thunkAPI.dispatch(
          bulkUpload({
            token: args.token,
            csvObj: args.csvFile.name,
            localization: args.localization,
          })
        );
      }

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error uploading CSV to AWS"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const bulkUpload = createAsyncThunk(
  "clientproducts/bulkUpload",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${args.token}`,
          "Accept-Language": args.localization,
        },
        //
      };
      const response = await api.post(
        `${baseURL}/v1/admin/products/bulk`,
        { csvObj: args.csvObj },
        config
      );
      if (response.data.statusToken) {
        thunkAPI.dispatch(
          bulkUploadStatusPoll({
            token: args.token,
            statusToken: response.data.statusToken,
            localization: args.localization,
          })
        );
      }

      thunkAPI.dispatch(setProductFeedback({ failures: [] }));
      thunkAPI.dispatch(setProductBulkDetails({ name: args.csvObj }));
      thunkAPI.dispatch(setProductBulkStatus("uploading"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "bulk upload error"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const bulkUploadStatusPoll = createAsyncThunk(
  "clientproducts/bulkUploadStatusPoll",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${args.token}`,
          "Accept-Language": args.localization,
        },
      };
      const response = await api.get(
        `${baseURL}/v1/admin/products/bulk/check/${args.statusToken}`,
        config
      );
      if (response.data && response.data.status === "completed") {
        // thunkAPI.dispatch(
        //   successSnack('Bulk CSV upload completed successfully')
        // );
        thunkAPI.dispatch(setProductBulkStatus("success"));
        return await response.data;
      } else if (
        response.data &&
        response.data.status === "completed with error(s)"
      ) {
        thunkAPI.dispatch(setProductFeedback(response.data));
        thunkAPI.dispatch(setProductBulkStatus("success with errors"));
      } else if (response.data && response.data.status === "incomplete") {
        setTimeout(() => {
          thunkAPI.dispatch(
            bulkUploadStatusPoll({
              token: args.token,
              statusToken: args.statusToken,
              localization: args.localization,
            })
          );
        }, 5000);
      } else {
        thunkAPI.rejectWithValue({
          error: "An error occurred with the bulk upload",
        });
        thunkAPI.dispatch(
          setProductFeedback({
            failures: [],
            errorMessage: "An error occurred with the bulk upload",
          })
        );
        thunkAPI.dispatch(setProductBulkStatus("error"));
      }
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "bulk upload error"
          )
        );

        thunkAPI.dispatch(
          setProductFeedback({
            failures: [],
            errorMessage:
              error.response.data.error_description || "bulk upload error",
          })
        );
        thunkAPI.dispatch(setProductBulkStatus("error"));
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "clientproducts/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreProducts(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const initial = {
  clientProduct: {},
  clientProductsList: [],
  loading: "idle",
  message: "",
  error: "",
  productFeedback: { failures: [] },
  productBulkDetails: { name: "" },
  productBulkStatus: "",
  productsAmount: "",
  lastQuery: "",
};

const clientProductsSlice = createSlice({
  name: "clientProducts",
  initialState: initial,
  reducers: {
    resetProduct(state, action) {
      state.clientProductsList = { data: [] };
      state.loading = "idle";
    },
    setProduct(state, action) {
      state.clientProduct = action.payload;
    },
    setProductFeedback: (state, action) => {
      state.productFeedback = action.payload;
    },
    setProductBulkDetails: (state, action) => {
      state.productBulkDetails = action.payload;
    },
    setProductBulkStatus: (state, action) => {
      state.productBulkStatus = action.payload;
    },
    resetBulk: (state, action) => {
      state.productBulkStatus = "";
      state.productBulkDetails = { name: "" };
      state.productFeedback = { failures: [] };
    },
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setProductsAmount: (state, action) => {
      state.productsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state) => {
      state.clientProductsList = { data: [] };
      state.loading = "loading";
    });
    builder.addCase(fetchProducts.fulfilled, (state, { payload }) => {
      state.error = "";
      state.clientProductsList = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreProducts.fulfilled, (state, { payload }) => {
      state.error = "";
      state.clientProductsList = state.clientProductsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreProducts.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      if (state.clientProductsList.length) {
        state.clientProductsList = state.clientProductsList.sort(function (
          a,
          b
        ) {
          return a.id - b.id;
        });
      }
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchProductByID.pending, (state) => {
      // state.product = {};
      state.loading = "loading";
    });
    builder.addCase(fetchProductByID.fulfilled, (state, { payload }) => {
      state.error = "";
      state.product = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchProductByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createProduct.pending, (state) => {
      state.message = "";
      // state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createProduct.fulfilled, (state, { payload }) => {
      // state.message = payload;
      // state.loading = "loaded";
    });
    builder.addCase(createProduct.rejected, (state, action) => {
      // state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateProduct.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateProduct.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateProduct.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(preSignedURL.pending, (state) => {
      state.url = "";
      // state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(preSignedURL.fulfilled, (state, { payload }) => {
      state.url = payload.preSignedURL;
      // state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(preSignedURL.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const {
  setProduct,
  setProductFeedback,
  setProductBulkDetails,
  setProductBulkStatus,
  resetBulk,
  setLastQuery,
  setProductsAmount,
} = clientProductsSlice.actions;

export const selectClientProducts = createSelector(
  (state) => ({
    clientProducts: state.clientProducts,
    clientProductsList: state.clientProducts.clientProductsList,
    loading: state.clientProducts.loading,
    error: state.clientProducts.error,
    clientProduct: state.clientProducts.clientProduct,
    productBulkStatus: state.clientProducts.productBulkStatus,
    productBulkDetails: state.clientProducts.productBulkDetails,
    productFeedback: state.clientProducts.productFeedback,
    productsAmount: state.clientProducts.productsAmount,
    lastQuery: state.clientProducts.lastQuery,
  }),
  (state) => state
);
export default clientProductsSlice.reducer;
